'use client';

import Image from 'next/image';
import Link from 'next/link';
import type { ProviderMarker } from '@paction-2.0/ui';
import { LazyMapView } from '@/features/puppy-search/components/LazyMapView';

import styles from './styles/homeMapCallout.module.scss';

export type HomeMapCalloutClientProps = {
  className?: string;
  providerMarkers: ProviderMarker[];
};

export function HomeMapCalloutClient({
  className,
  providerMarkers
}: HomeMapCalloutClientProps) {
  // Center matches legacy paction app: lat 50, lng -89
  // Zoom 3.75 to show all of Canada with focus on southern provinces
  const CANADA_CENTER: [number, number] = [50, -89];

  return (
    <section className={`${styles.mapCallout} ${className || ''}`}>
      <div className={styles.mapContent}>
        <h2 className={styles.mapTitle}>
          <Image
            src="/icons/search-icon.svg"
            alt="Search"
            width={32}
            height={32}
          />
          Search for a Pup
        </h2>
        <p className={styles.mapDescription}>
          Browse Reputable Breeders who meet Paction&apos;s Certification
          standards
        </p>
        <Link href="/puppies" className={styles.mapButton}>
          Search
        </Link>
      </div>
      <div className={styles.mapMediaFrame}>
        <LazyMapView
          mapSource="leaflet"
          zoom={3.75}
          center={CANADA_CENTER}
          disableInteraction
          radius={50000}
          providerMarkers={providerMarkers}
        />
      </div>
    </section>
  );
}
